import { BaseEntity } from './base-entity';

export class ThreatType extends BaseEntity {
  numericValue: number;
  threats: Array<BaseEntity> = [];
  events: Array<BaseEntity> = [];
}
